export const initScroll = function () {
  let starTime = 0; // 开始时间
  let diffTime = 0; // 时间差
  let scrollPos; // 滚动位置
  function setScrollTopCookie(scrollPos) {
    // 存储滚动条位置到cookies中
    document.cookie = "scrollTop=" + scrollPos;
  }
  function delScrollTopCookie() {
    // 删除滚动条位置的cookie
    document.cookie = "scrollTop=;expires=" + new Date().toGMTString()
  }

  window.onbeforeunload = function () {
    if (typeof window.pageYOffset != 'undefined') {
      scrollPos = window.pageYOffset;
    }
    else if (typeof document.compatMode != 'undefined' && document.compatMode != 'BackCompat') {
      scrollPos = document.documentElement.scrollTop;
    }
    else if (typeof document.body != 'undefined') {
      scrollPos = document.body.scrollTop;
    }
    starTime = Date.now()
  }
  window.onunload = function () {
    diffTime = Date.now() - starTime;
    const key = '-------text-----'
    localStorage.setItem('diffTime', diffTime)
    if (diffTime <= 15) {
      localStorage.setItem(key, '这是关闭')
      delScrollTopCookie()
      return
    }
    setScrollTopCookie(scrollPos)
    localStorage.setItem(key, '这是刷新')
  };

  window.onload = function () {
    const reg = /scrollTop=([^;]+)(;|$)/
    const arr = document.cookie.match(reg)
    if (arr == null) {
      return
    }
    setTimeout(() => {
      window.scrollTo({
        top: parseInt(arr[1]),
        behavior: "smooth"
      });
      // 删除cookie
      delScrollTopCookie()
    }, 2000)
  }
}

export const setSeoFun = function (obj) {
  const META = 'meta'
  const NAME = 'name'
  const CONTENT = 'content'
  const KEYWORDS = 'keywords'
  const DESCRIPTION = 'description'
  const {meta_title, meta_keywords, meta_description} = obj
  document.title = meta_title || 'Smiling Home'
  const headEl = document.getElementsByTagName('head')[0];
  let keywordsEl = document.querySelector(`meta[name=${KEYWORDS}]`);
  if (!keywordsEl) {
    keywordsEl = document.createElement(META)
    keywordsEl.setAttribute(NAME, KEYWORDS)
    headEl.append(keywordsEl)
  }
  keywordsEl.setAttribute(CONTENT, meta_keywords || '');
  let descriptionEl = document.querySelector(`meta[name=${DESCRIPTION}]`)
  if (!descriptionEl) {
    descriptionEl = document.createElement(META)
    descriptionEl.setAttribute(NAME, DESCRIPTION)
    headEl.append(descriptionEl)
  }
  descriptionEl.setAttribute(CONTENT, meta_description || '')
}

export const removeToken = () => sessionStorage.removeItem('token');
export const getToken = () => sessionStorage.getItem('token');


// WEBPACK FOOTER //
// ./src/common/index.js